const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION';
const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';

export function pushNotification(data) {
    return {
        type: PUSH_NOTIFICATION,
        data
    };
}

export function dismissNotification(id) {
    return {
        type: DISMISS_NOTIFICATION,
        id
    };
}

const initialState = {
    alerts: []
};

let INCREMENT_ID = 1;

export default function alertnotifier(state = initialState, action) {
    switch (action.type) {
        case PUSH_NOTIFICATION:
            return {
                ...state,
                alerts: [{
                    ...action.data,
                    id: INCREMENT_ID++
                }]
            };

        case DISMISS_NOTIFICATION:
            return {
                ...state,
                alerts: state.alerts.filter((alert) => alert.id !== action.id)
            };

        default:
            return state;
    }
}
